import { Box, Tabs, TabList, Tab, TabPanel, ListItemDecorator, tabClasses, useColorScheme } from "@mui/joy";
import { Package, Wrench, Calculator } from "lucide-react";
import { useSearchParams } from "react-router-dom";

import Materials from "./Materials";
import Labor from "./Labor";
import Estimating from "./Estimating";

/** Below app header (48px) + sticky task progress stepper (~70px). */
const STICKY_TAB_TOP = "118px";

const tabListSx = {
    gap: 2,
    width: "calc(100% + 48px)",
    mx: -3,
    px: 2.5,
    position: "sticky",
    top: STICKY_TAB_TOP,
    zIndex: 1001,
    borderColor: "divider",
    borderBottom: "1px solid",
    borderBottomColor: "divider",
    [`&& .${tabClasses.root}`]: {
        flex: "initial",
        color: "text.secondary",
        opacity: 0.7,
        background: "transparent",
        bgcolor: "transparent",
        paddingLeft: 0.5,
        paddingRight: 0.5,
        paddingBottom: 1.5,
        paddingTop: 1.5,
        fontWeight: 600,
        "&:hover": {
            bgcolor: "transparent",
        },
        [`&.${tabClasses.selected}`]: {
            color: "primary.plainColor",
            fontWeight: 600,
            opacity: 1,
            "&::after": {
                height: 2,
                borderTopLeftRadius: 3,
                borderTopRightRadius: 3,
                bgcolor: "primary.500",
            },
        },
    },
};

export default function EstimateContractTabs(props: any) {
    const { measurements, attributes, setIsNextStageEligible } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("taskTab") || "materials";
    const { mode } = useColorScheme();

    return (
        <Box mt={2}>
            <Tabs
                value={activeTab}
                sx={{ width: "100%" }}
                onChange={(_, value) => {
                    setSearchParams((prev) => {
                        const params = new URLSearchParams(prev);
                        params.set("taskTab", value as string);
                        return params;
                    });
                }}
            >
                <TabList
                    sx={{
                        ...tabListSx,
                        bgcolor: mode === "light" ? "background.body" : "background.surface",
                    }}
                >
                    <Tab value="materials">
                        <ListItemDecorator>
                            <Package size={16} />
                        </ListItemDecorator>
                        Materials
                    </Tab>
                    <Tab value="labor">
                        <ListItemDecorator>
                            <Wrench size={16} />
                        </ListItemDecorator>
                        Labor
                    </Tab>
                    <Tab value="estimating">
                        <ListItemDecorator>
                            <Calculator size={16} />
                        </ListItemDecorator>
                        Estimating
                    </Tab>
                </TabList>

                <TabPanel value="materials" keepMounted sx={{ px: 0, pt: 2 }}>
                    <Materials measurements={measurements} attributes={attributes} setIsNextStageEligible={setIsNextStageEligible} />
                </TabPanel>

                <TabPanel value="labor" keepMounted sx={{ px: 0, pt: 2 }}>
                    <Labor measurements={measurements} />
                </TabPanel>

                <TabPanel value="estimating" keepMounted sx={{ px: 0, pt: 2 }}>
                    <Estimating measurements={measurements} />
                </TabPanel>
            </Tabs>
        </Box>
    );
}
